import axios from './axios';
import config from '../../helpers/config';

export default (designId, containerId, newName, newLabel) => (
  axios.post(
    `${config.designBuilderLoadDesignPath}/${designId}/containers/${containerId}/copy`,
    {
      name: newName,
      label: newLabel,
    },
  )
);
